<template>
    <v-card>
        <v-toolbar class="toolbar-header-color">
            <v-toolbar-title>
                {{$t('subjectreportlist')}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn dark text @click="dialogueClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <h4>
            खाद्य व्यवस्था तथा व्यापार कम्पनी लिमिटेड
            आ.ब {{fiscalyearName}}  को बार्षिक नीति तथा कार्यक्रम र बजेट
        </h4>
        <v-card-text>
           

            <table ref="myTable" id="myTable" style="border-collapse:collapse;">
                <thead>
                    <tr>
                        <th class="header-cell" rowspan="2">क्र.सं.</th>
                        <th class="header-cell" rowspan="2">विषय</th>
                        <th class="header-cell" rowspan="2">कार्यक्रम</th>
                        <th class="header-cell" rowspan="2">लक्ष्य</th>
                        <th class="header-cell" colspan="2">बजेट रु हजारमा</th>
                        <th class="header-cell" rowspan="2">जम्मा</th>
                        <th class="header-cell" rowspan="2">अनुसूची</th>
                        <th class="header-cell" rowspan="2">उपलब्धि</th>
                    </tr>
                    <tr>
                        <th class="header-cell">चालु</th>
                        <th class="header-cell">पूँजीगत</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(subject, subjectIndex) in rows">
                        <tr :key="'subject-'+subjectIndex">
                            <td class="header-cell subject-background" :rowspan="subject.targetCount+subject.programs.length+1">
                                {{subjectIndex +1}}
                            </td>
                            <td class="header-cell subject-background" :rowspan="subject.targetCount+subject.programs.length+1">
                                {{subject.subjectName}}
                            </td>
                        </tr>
                        <template v-for="(program, programIndex) in subject.programs">
                            <tr :key="'program-'+programIndex">
                                <td class="header-cell subject-background" :rowspan="program.targetCount+1">
                                    {{program.programName}}
                                </td>
                            </tr>
                            <template v-for="(target, targetsIndex) in program.targets">
                                <tr :key="'target-'+targetsIndex">
                                    <td class="header-cell subject-background">
                                        {{target.targetName}}
                                    </td>
                                    <td class="header-cell subject-background">{{target.currentAmount}}</td>
                                    <td class="header-cell subject-background">{{target.capitalAmount}}</td>
                                    <td class="header-cell subject-background">{{target.totalAmount}}</td>
                                    <td class="header-cell subject-background">{{target.anusuchiName}}</td>
                                    <td class="header-cell subject-background">{{target.achievement}}</td>
                                </tr>
                            </template>
                        </template>
                        <tr :key="'subject-total-'+subjectIndex">
                            <th class="header-cell subject-background-total" colspan="4">
                                <strong>
                                    जम्मा
                                </strong>
                            </th>
                            <th class="header-cell subject-background-total"><strong>{{ subject.currentAmount }}</strong></th>
                            <th class="header-cell subject-background-total"><strong>{{ subject.capitalAmount }}</strong></th>
                            <th class="header-cell subject-background-total"><strong>{{ subject.totalAmount}}</strong></th>
                            <th class="header-cell subject-background-total" colspan="2"></th>
                        </tr>
                    </template>
                    <tr>
                        <th class="header-cell" colspan="4">
                            <strong>
                                जम्मा
                            </strong>
                        </th>
                        <th class="header-cell"><strong>{{ subjectTotal.currentAmount }}</strong></th>
                        <th class="header-cell"><strong>{{ subjectTotal.capitalAmount }}</strong></th>
                        <th class="header-cell"><strong>{{ subjectTotal.totalAmount}}</strong></th>
                        <th class="header-cell" colspan="2"></th>
                    </tr>
                </tbody>


            </table>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="exportToExcel">Export</v-btn>
            <v-btn dark color="red darken-1" @click="dialogueClose">{{$t('cancel')}}</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import * as XLSX from 'xlsx'
    import axios from "axios";
    export default {
        name: "ReportList",

        props: ["subjectReportViewData"],
        data() {
            return {
                role: this.$store.getters.getUserRole,
                rows: [],
                fiscalyearName: "",
                formData: {},
                snackbar: {
                    color: '',
                    snackbar: false,
                    text: '',
                    timeout: 6000,
                    isLoading: false,
                    formModal: false,
                    viewFormComponent: false,
                    editFormComponent: false,
                    dialogDelete: false,
                    dynamicComponent: {
                        current: 'SectionsForm'
                    }
                }
            };
        },

        methods: {

            formResponse(responseObj) {
                this.snackbar.color = responseObj.status ? 'success' : 'red'
                this.snackbar.text = responseObj.text
                this.snackbar.snackbar = true
                this.loadItems();
            },
            dialogueClose() {
                this.formData = {}
                this.$emit('dialogueCloseView')
            },
            async loadItems() {
                axios.get("ReportSettings/GetPoliciesProgramBudgetLevelReport/" + this.subjectReportViewData.fiscalYearID).then(response => {
                    console.log('dasdad', response)
                    this.fiscalyearName = response.data.fiscalYearName
                    this.rows = response.data.policiesProgramBudgetReportModel
                })
            },
            
            exportToExcel() {
      const table = this.$refs.myTable;
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.table_to_sheet(table, { raw: true });

      // Handling rowspan and colspan
      const range = XLSX.utils.decode_range(ws['!ref']);
      for (let R = range.s.r; R <= range.e.r; ++R) {
        for (let C = range.s.c; C <= range.e.c; ++C) {
          const cellAddress = { c: C, r: R };
          const cellRef = XLSX.utils.encode_cell(cellAddress);
          const cell = ws[cellRef];

          if (cell && cell.rowSpan > 1) {
            // For cells with rowspan, merge the cells in the sheet
            const mergeCell = {
              s: { c: C, r: R },
              e: { c: C, r: R + cell.rowSpan - 1 },
            };
            const mergeRef = XLSX.utils.encode_range(mergeCell);
            ws[mergeRef] = { t: 's', v: cell.innerText };
          }

          if (cell && cell.colSpan > 1) {
            // For cells with colspan, merge the cells in the sheet
            const mergeCell = {
              s: { c: C, r: R },
              e: { c: C + cell.colSpan - 1, r: R },
            };
            const mergeRef = XLSX.utils.encode_range(mergeCell);
            ws[mergeRef] = { t: 's', v: cell.innerText };
          }
        }
      }

      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

      const blob = new Blob([wbout], { type: 'application/octet-stream' });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = 'table_export.xlsx'; // Set the desired filename with .xlsx extension
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    },
        },
        computed: {
            subjectTotal() {
                const sumData = {
                    currentAmount: 0,
                    capitalAmount: 0,
                    totalAmount: 0
                    }
                this.rows.map(res => {
                    sumData.currentAmount += res.currentAmount
                    sumData.capitalAmount += res.capitalAmount
                    sumData.totalAmount += res.totalAmount
                })
                return sumData
            },
            processedRows() {
                const processedRows = [];
                this.rows.forEach((subject) => {
                    subject.programs.forEach((program, programIndex) => {
                        processedRows.push({
                            subjectName: subject.subjectName,
                            programName: program.programName,
                            rowspanSubject: programIndex === 0 ? subject.targetCount : 0,
                            rowspanProgram: program.targetCount,
                        });
                    });
                });
                return processedRows;
            },
        },

        mounted() {
            this.loadItems()

        },

    }
</script>

<style scoped>
    .subject-background{
        background-color: white;
    }
    .subject-background-total {
        background-color: #abaed366
    }
</style>
